var render = function render(){var _vm=this,_c=_vm._self._c;return _c('administration-layout',[_c('div',{staticClass:"flex flex-col items-center py-4"},[_c('policies-and-templates-form',{attrs:{"show-checklist-config":true,"show-print-config":true,"show-order-status-config":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }